import { Drawer, ButtonToolbar, Button, IconButton, Placeholder } from "rsuite";
import { useState } from "react";
import MenuIcon from "@rsuite/icons/Menu";
import { Flex, View } from "@aws-amplify/ui-react";
import NavigationSide from "./NavigationSide";

export default function () {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <View>
      <IconButton
        icon={<MenuIcon />}
        onClick={() => handleOpen()}
      ></IconButton>

      <Drawer size="300px" placement="left" open={open} onClose={() => setOpen(false)}>
        <Drawer.Header>
          <Drawer.Title>Total Care Compass</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <NavigationSide onItemClick={() => setOpen(false)} />
        </Drawer.Body>
      </Drawer>
    </View>
  );
}
